import { ChangeEvent, KeyboardEvent, memo, useCallback, useState } from "react";
import { SendIcon } from '../../../../components/icons/send-icon';
import { ErrorMessage, Input, InputContainer, InputGroup, SendButton } from './styles';
import { validateEmail } from '../../../../utils/validators';
import { useAppDispatch, useAppSelector } from '../../../../../common/store';
import { sendInputSubmission } from '../../../../../common/store/chat/thunks/send-input-submission';
import { inputCollectionSelector } from "../../../../../common/store/chat/selectors";

export const InMessageInput = () => {
  const dispatch = useAppDispatch();
  const inputCollection = useAppSelector(inputCollectionSelector);
  const [inputValue, setInputValue] = useState('');
  const [submittingFlag, setSubmittingFlag] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleKeyDown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') return;

    handleSend();
  }, [inputValue]);

  const handleSend = useCallback(async () => {
    if (!inputCollection) return;

    setSubmittingFlag(true);
    setErrorMessage('');

    const value = inputValue.trim();
    const { inputLabel } = inputCollection;

    if (!value) {
      setSubmittingFlag(false);
      return;
    }

    if (inputCollection.inputLabel.toLowerCase().includes('email') && !validateEmail(value)) {
        console.error("Invalid email address");
        setSubmittingFlag(false);
        setErrorMessage('Please enter a valid company email address.');
        return;
    }

    await dispatch(sendInputSubmission({ inputLabel, value }));

    setInputValue('');
    setSubmittingFlag(false);
  }, [inputValue, inputCollection]);

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setInputValue(target.value);
    setErrorMessage('');
  }, []);

  if (!inputCollection) {
    return null;
  }

  return (
    <InputContainer>
      {submittingFlag ? (
          <div>
            Submitting....
          </div>
      ):(
        <InputGroup className="inline_input_group">
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <Input
                className="inline_input"
                placeholder={inputCollection.placeholder}
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
            <SendButton
              width="20px"
              height="20px"
              className="inline_input_confirm_button"
              onClick={handleSend}
            >
              <SendIcon />
            </SendButton>
        </InputGroup>
      )}
    </InputContainer>
  )
};
